import investmentReturns from './investment-returns';
import investmentSales from './investment-sales';
import investmentValuations from './investment-valuations';
import investments from './investments';

let messages = Object.assign({}, investmentReturns, investmentSales, investmentValuations, investments);

export default messages;
